import { container, title } from "assets/jss/westmorland-lodge-44.jsx";

import imagesStyle from "assets/jss/westmorland-lodge-44/imagesStyles.jsx";

const calendarPageStyle = {
  container: {
    zIndex: "12",
    color: "#FFFFFF",
    ...container
  },
  description: {
    margin: "1.071rem auto 0",
    maxWidth: "600px",
    color: "#999"
  },
  name: {
    marginTop: "-80px"
  },
  ...imagesStyle,
  main: {
    background: "#FFFFFF",
    position: "relative",
    zIndex: "3",
    maxWidth: "1100px",
    textAlign: "center !important"
  },
  mainRaised: {
    margin: "-60px auto 0px",
    borderRadius: "6px",
    boxShadow:
      "0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)",
    padding: "30px"
  },
  title: {
    ...title,
    display: "inline-block",
    position: "relative",
    marginTop: "30px",
    minHeight: "32px",
    textDecoration: "none",
    color: "#FFFFFF"
  },
  navWrapper: {
    margin: "20px auto 50px auto",
    textAlign: "center"
  }
};

export default calendarPageStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/westmorland-lodge-44/views/calendarPage.jsx